import type { GanttIndicator } from "@/modules/carga-trabalho";

/** Itens da legenda do Gantt de Profissionais, na ordem do protótipo. */
export const LEGEND: { key: string; label: string }[] = [
  { key: "planejamento", label: "Planejamento" },
  { key: "obra", label: "Obra" },
  { key: "fechamento", label: "Fechamento" },
  { key: "cancelada", label: "Cancelada" },
  { key: "indisponibilidade", label: "Indisponibilidade" },
];

/** Indicadores exibidos no Gantt (modal "Exibir indicadores no Gantt"). */
export interface GanttIndicadores {
  obra: boolean;
  cancelada: boolean;
}

/** Ação do ⋮ das linhas com conflito em aberto (HU 2434). */
export const RESOLVER_CONFLITO_LABEL = "Resolver Conflito";

/** Bolinha de cada indicador do Gantt no modal "Exibir indicadores" (Figma 7094:74952): as cores das barras e da legenda. */
export const INDICATOR_COLORS: Record<GanttIndicator, string> = {
  planejamento: "var(--ds-color-blue-400)",
  obra: "var(--ds-color-primary-900)",
  fechamento: "var(--ds-color-green-400)",
  cancelada: "var(--ds-color-red-400)",
  indisponibilidade: "var(--ds-color-gray-400)",
};
